import PostBaseTemplate from "../PostBaseTemplate";
import YoutubeComponent from "./YoutubeComponent";
function YoutubeWrapper({
  platform,
  url,
  downloaded_path,
  videoRef,
  muted,
  onManualUnmute,
  onManualMute,
  caption,
  creatorName,
}) {
  if (!url) return <p>Invalid URL</p>;

  return (
    <PostBaseTemplate platform={platform} url={url}>
      <YoutubeComponent
        downloaded_path={downloaded_path}
        muted={muted}
        url={url}
        creatorName={creatorName}
        videoRef={videoRef}
        caption={caption}
        onManualUnmute={onManualUnmute}
        onManualMute={onManualMute}
      />
    </PostBaseTemplate>
  );
}

export default YoutubeWrapper;

// import React, { useEffect, useRef, useState } from "react";
// import PostBaseTemplate from "../PostBaseTemplate";

// function YoutubeWrapper({ downloaded_path }) {
//   const containerRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   console.log("YoutubeWrapper render", { downloaded_path });

//   if (!downloaded_path) {
//     console.warn("No downloaded_path provided.");
//     return <p>No video file found.</p>;
//   }

//   const fullUrl = `https://genz-staging.feeltiptop.com/${downloaded_path}`;
//   const ext = downloaded_path?.split(".").pop().toLowerCase();
//   console.log("Media extension:", ext);
//   console.log("Full media URL:", fullUrl);

//   useEffect(() => {
//     const element = containerRef.current;
//     if (!element) {
//       console.warn("containerRef is not attached to any element.");
//       return;
//     }

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         console.log("IntersectionObserver entry:", entry);
//         const inView = entry.isIntersecting && entry.intersectionRatio >= 0.1;
//         console.log("Is in view?", inView);
//         setIsVisible(inView);
//       },
//       { threshold: 0.1 }
//     );

//     console.log("Observing element:", element);
//     observer.observe(element);

//     return () => {
//       console.log("Unobserving element:", element);
//       if (element) observer.unobserve(element);
//     };
//   }, []);

//   useEffect(() => {
//     console.log("isVisible state changed:", isVisible);
//   }, [isVisible]);

//   return (
//     <PostBaseTemplate platform="youtube" url={downloaded_path}>
//       <div
//         ref={containerRef}
//         style={{
//           width: "325px",
//           aspectRatio: "1 / 1.75",
//           backgroundColor: "black",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {isVisible ? (
//           ["mp4", "webm", "ogg"].includes(ext) ? (
//             <video
//               src={fullUrl}
//               controls
//               autoPlay
//               muted
//               loop
//               playsInline
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               onPlay={() => console.log("Video started playing.")}
//               onError={(e) => console.error("Video failed to load:", e)}
//             />
//           ) : ["jpg", "jpeg", "png", "gif", "webp"].includes(ext) ? (
//             <img
//               src={fullUrl}
//               alt="Media content"
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               onLoad={() => console.log("Image loaded.")}
//               onError={() => console.error("Image failed to load.")}
//             />
//           ) : (
//             <p>Unsupported media format: {ext}</p>
//           )
//         ) : (
//           <p style={{ color: "#fff" }}>Waiting for visibility...</p>
//         )}
//       </div>
//     </PostBaseTemplate>
//   );
// }

// export default YoutubeWrapper;
